export default "__VITE_ASSET__ClC0tKsI__"